export const EmailSidebarMenuList = [
  {
    title: 'Inbox',
    icon: 'icon-import',
    notification: 236,
  },
  {
    title: 'All Mail',
    icon: 'icon-folder',
  },
  {
    title: 'Sent',
    icon: 'icon-new-window',
    notification: 69,
  },
  {
    title: 'Draft',
    icon: 'icon-pencil-alt',
    notification: 59,
  },
  {
    title: 'Trash',
    icon: 'icon-trash',
    notification: 99,
  },
  {
    title: 'Important',
    icon: 'icon-info-alt',
  },
  {
    title: 'Starred',
    icon: 'icon-star',
  },
  {
    title: 'Unread',
    icon: 'icon-email',
  },
  {
    title: 'Spam',
    icon: 'icon-export',
  },
  {
    title: 'Outbox',
    icon: 'icon-share',
  },
  {
    title: 'Update',
    icon: 'icon-file',
  },
  {
    title: 'Alert',
    icon: 'icon-bell',
  },
  {
    title: 'Notes',
    icon: 'icon-notepad',
    notification: 20,
  },
];
